export const columnsDataDevelopment = [
  {
    Header: "NAME",
    accessor: "name",
  },
  {
    Header: "TECH",
    accessor: "tech",
  },
  {
    Header: "DATE",
    accessor: "date",
  },
  {
    Header: "PROGRESS",
    accessor: "progress",
  },
];

export const columnsDataCheck = [
  {
    Header: "NAME",
    accessor: "name",
  },
  {
    Header: "PROGRESS",
    accessor: "progress",
  },
  {
    Header: "QUANTITY",
    accessor: "quantity",
  },
  {
    Header: "DATE",
    accessor: "date",
  },
];

export const columnsDataColumns = [
  {
    Header: "NAME",
    accessor: "name",
  },
  {
    Header: "PROGRESS",
    accessor: "progress",
  },
  {
    Header: "QUANTITY",
    accessor: "quantity",
  },
  {
    Header: "DATE",
    accessor: "date",
  },
];

export const columnsDataComplex = [
  {
    Header: "NAME",
    accessor: "name",
  },
  {
    Header: "STATUS",
    accessor: "status",
  },
  {
    Header: "DATE",
    accessor: "date",
  },
  {
    Header: "PROGRESS",
    accessor: "progress",
  },
];

export const columnsAssetTable = [  
  {
    Header: "ACME Hostname",
    accessor: "ACME HOSTNAME",
  },  
  {
    Header: "Business Unit",
    accessor: "BU"
  },
  {
    Header: "IP",
    accessor: "IP",
  },
  {
    Header: "Operating System",
    accessor: "OS",
  },
  // {
  //   Header: "Tech Hostname",
  //   accessor: "HOSTNAME",
  // },
  // {
  //   Header: "Protocol",
  //   accessor: "protocol",
  // },  
  {
    Header: "Insecure Protocol",
    accessor: "insecure_protocol",
  },
  // {
  //   Header: "Host Risk",
  //   accessor: "host_risk",
  // },
  {
    Header: "ACE Score",
    accessor: "score",
  },
  {
    Header: "Days to restore",
    accessor: "num_days_to_restore"
  },
  {
    Header: "Revenue Impacted ($)",
    accessor: ""
  }
];

export const businessUnitsColumns = [
  {
    Header: "Name",
    accessor: "name",
  },
  {
    Header: "Description",
    accessor: "description",
  },
  {
    Header: "Annual Revenue",
    accessor: "annual_revenue"
  },
  {
    Header: "Number of Assets",
    accessor: "asset_count"
  },
  {
    Header: "Number of CVEs",
    accessor: "cve_count"
  }
];

// export const columnsAssetTable = [
//   {
//     Header: "Host/IP",
//     accessor: "host",
//   },
//   {
//     Header: "Hostname",
//     accessor: "hostname",
//   },
//   {
//     Header: "Operating System",
//     accessor: "os",
//   },
//   {
//     Header: "CVE",
//     accessor: "cve",
//   },
//   {
//     Header: "Description",
//     accessor: "name",
//   },
//   {
//     Header: "Protocol",
//     accessor: "protocol",
//   },
//   {
//     Header: "Risk Factor",
//     accessor: "risk_score",
//   },
//   {
//     Header: "VPR Score",
//     accessor: "cve_score",
//   },
//   {
//     Header: "Host Risk",
//     accessor: "host_risk",
//   },
//   {
//     Header: "Computed Value",
//     accessor: "computed_value",
//   },
// ];